import React, { lazy, Suspense } from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';

import { LoginRequired } from '@components/LoginRequired';
import { NotFoundView } from '@views/NotFoundView';
import {
  userDatabaseUrl,
  userOfferApplicationsUrl,
  userOffersActiveUrl,
  userOffersExpiredUrl,
} from '@urls';

// Lazy load user views; NotFound is static to avoid extra chunk
const UserDatabaseView = lazy(() =>
  import('@views/User').then(module => ({ default: module.UserDatabaseView })),
);
const UserOfferApplicationsView = lazy(() =>
  import('@views/User').then(module => ({ default: module.UserOfferApplicationsView })),
);
const UserOffersActiveView = lazy(() =>
  import('@views/User').then(module => ({ default: module.UserOffersActiveView })),
);
const UserOffersExpiredView = lazy(() =>
  import('@views/User').then(module => ({ default: module.UserOffersExpiredView })),
);

const withLogin = (Component: React.ComponentType<any>) => (routeProps: any) => (
  <LoginRequired>
    <Component {...routeProps} />
  </LoginRequired>
);

export const UserRouter: React.FC<RouteComponentProps> = () => (
  <Suspense fallback={null}>
    <Switch>
      <Route
        exact
        path={userOffersExpiredUrl}
        render={withLogin(UserOffersExpiredView)}
      />
      <Route
        exact
        path={userOffersActiveUrl}
        render={withLogin(UserOffersActiveView)}
      />
      <Route
        exact
        path={userOfferApplicationsUrl}
        render={withLogin(UserOfferApplicationsView)}
      />
      <Route
        exact
        path={userDatabaseUrl}
        render={withLogin(UserDatabaseView)}
      />
      <Route component={NotFoundView} />
    </Switch>
  </Suspense>
);
